import {h, Component, Fragment} from 'preact';
import {route} from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as P from "../desktop-templates/prematch-tournament.jsx";

export default class PrematchLiveEvents extends Component {
	componentWillMount() {
		LFeed.onUpdate(this.listener = () => this.setState({}))
	}
	componentDidUnmount() {
		LFeed.stopUpdate(this.listener)
	}
	bestSport(menu) {
		return Object.values(menu).sort((a, b) => a.order - b.order)[0]
	}
	render() {
		if (!LFeed.menu)
			return;
		const sport = this.bestSport(LFeed.menu);
		return <PrematchLiveEventsContent defaultSport={sport.id} />
	}
}

export class PrematchLiveEventsContent extends Component {
	preferredMarkets = {
		'/sport/1': {id: 14, outcomes: 3},
		'/sport/7': {id: 5, outcomes: 2},
		'/sport/9': {id: 39, outcomes: 2},
		'/sport/10': {id: 6, outcomes: 3},
		'/sport/26': {id: 4, outcomes: 2},
	}
	state = {
		currentSport: null
	};
	componentWillMount() {
		this.setState({
			currentSport: this.props.defaultSport
		});
	}
	bestFourSports(menu) {
		return Object.values(menu)
			.filter(sport => this.preferredMarkets[sport.id])
			.sort((a, b) => a.order - b.order)
			.slice(0, 4)
	}
	setCurrentSport(sportId) {
		this.setState({
			currentSport: sportId
		});
	}
	isCurrentSport(sportId) {
		return this.state.currentSport == sportId;
	}
	getSomeEvents() {
		const sport = LFeed.menu[this.state.currentSport];
		if (!sport)
			return [];
		const tournaments = Object.values(sport.sub).sort((a, b) => a.order - b.order);
		return tournaments.slice(0, 6).flatMap(tournament => Object.values(tournament.sub)).slice(0, 6);
	}
	getCurrentSportId() {
		return this.state.currentSport;
	}
	preferredMarketForEvent(event) {
		return event.sub['/market/'+event.id.split('/')[2]+'/'+this.preferredMarkets[this.getCurrentSportId()].id];
	}
	render() {
		return <div>
		  <P.CardHeaderRow>
			<P.ThreeDots />
			<P.CardHeaderTitle><Trans>Main Live Events</Trans></P.CardHeaderTitle>
			<P.CardHeaderSports>
			  {this.bestFourSports(LFeed.menu).map(sport => (
				<P.SportNameButton onClick={() => this.setCurrentSport(sport.id)} active={this.isCurrentSport(sport.id)}>
				  <M.SportFlagIcon sport={sport} /> {sport.name}
				</P.SportNameButton>
			  ))}
			</P.CardHeaderSports>
		  </P.CardHeaderRow>
		  <P.OddsTableHeadRow>
			<P.HeadRowCellId><Trans>Time</Trans></P.HeadRowCellId>
			<P.HeadRowCellTime><Trans>Set</Trans></P.HeadRowCellTime>
			<P.HeadRowCellTime><Trans>Score</Trans></P.HeadRowCellTime>
			<P.HeadRowCellEvent><Trans>Event</Trans></P.HeadRowCellEvent>
			<P.OddsWidthContainer>
			  {this.preferredMarkets[this.getCurrentSportId()].outcomes == 3 ? <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>X</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>
			  : <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>}
			  <P.HeadMoreCell />
			</P.OddsWidthContainer>
		  </P.OddsTableHeadRow>
		  {this.getSomeEvents().map(event => <div>
			  <P.EventRow>
				<P.HeadRowCellId onClick={e => route('/live'+event.id)}><span class="truncate">{event.status.timer ? event.status.timer+"'" : ''}</span></P.HeadRowCellId>
				<P.HeadRowCellTime onClick={e => route('/live'+event.id)}><span class="text-xxs">{event.status.phase}</span></P.HeadRowCellTime>
				<P.HeadRowCellTime onClick={e => route('/live'+event.id)}><span class="font-bold text-kobaaccent-500">{event.current.result.join(' - ')}</span></P.HeadRowCellTime>
				<P.ContentRowCellEvent onClick={e => route('/live'+event.id)}>{event.home}{event.away ? ' - '+event.away : ''}</P.ContentRowCellEvent>
				<P.OddsWidthContainer>
				  <LiveEventOdds market={this.preferredMarketForEvent(event)} />
				  <P.MoreButton onClick={e => route('/live'+event.id)}>+</P.MoreButton>
				</P.OddsWidthContainer>
			  </P.EventRow>
		  </div>)}
		  <P.ShowMoreFooter onClick={e => route('/live/'+this.getCurrentSportId().split('/')[2])}><Trans>Show More</Trans> {'>>'}</P.ShowMoreFooter>
		</div>
	}
}

export class LiveEventOdds extends Component {
	render({market}) {
		return !!market
		? Object.values(market.sub).map(outcome => (
			<P.EventOddButton
				value={outcome && outcome.value}
				selected={outcome && Ticket.hasLiveOdds(outcome.id)}
				onClick={() => Ticket.toggleLiveOdds(outcome.id)} />
		))
		: <P.OddsWidthEmpty />
	}
}